import type { ContentTypeObject, CustomHtmlElement } from '../../types/pbTypes';
import type { PbBlock } from '../../types/pbBlocks';
import { getAdvanced, parseStyleString } from '../utils';

export type BlockType = ContentTypeObject & PbBlock;

/**
 * Aggregates the configuration of a block element.
 * @param node
 */
export function blockConfigAggregator(node: CustomHtmlElement): BlockType {
    const childNode = node.childNodes[0] as CustomHtmlElement;
    const style = parseStyleString(node.attributes.style);

    return {
        ...getAdvanced(node, style),
        richContent: childNode ? childNode.innerHTML : '',
        uniqueID: node.attributes['data-pb-style'],
    };
}
